// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://ertpstnzjpcpzexbjhak.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImVydHBzdG56anBjcHpleGJqaGFrIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTExNjU1MDUsImV4cCI6MjA2Njc0MTUwNX0.pL_YxO5QSeDyw5QLhlEuaOjQWIVxezmYzzvl6kvLgnQ";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});